class Progress {
    constructor(target, count) {
        this._percent = 0;
        this._step;
        this._direction = 'forward';

        this.nodes = {};
        this.nodes.wrapper = document.createElement('div');
        this.nodes.wrapper.className = 'progress__wrapper';

        this.nodes.element = document.createElement('div');
        this.nodes.element.className = 'progress';

        this.nodes.element.innerHTML = `<span class="decoration-0"></span>
        <span class="decoration-1"></span>
        <span class="decoration-2"></span>
        <span class="decoration-3"></span>
        <span class="decoration-4"></span>
        <span class="decoration-5"></span>
        <span class="decoration-6"></span>
        <span class="decoration-7"></span>
        <span class="decoration-8"></span>
        <span class="decoration-9"></span>
        <span class="decoration-10"></span>`;

        this.nodes.line = document.createElement('div');
        this.nodes.line.className = 'progress__line';

        this.nodes.lineDecorationWrapper = document.createElement('span');
        this.nodes.lineDecorationWrapper.className = 'decoration-wrapper';

        this.nodes.lineDecoration = document.createElement('span');
        this.nodes.lineDecoration.className = 'decoration-1';

        this.nodes.step = document.createElement('div');
        this.nodes.step.className = 'progress__steps';

        this.nodes.steps = [];
        this.nodes.links = [];

        let svgIcon = `<svg class="icon-1" width="45" height="45"><use xlink:href="#progress-step-1" /></svg>
        <svg class="icon-2" width="45" height="45"><use xlink:href="#progress-step-2" /></svg>
        <svg class="icon-3" width="45" height="45"><use xlink:href="#progress-step-3" /></svg>`;

        for (let index = 1; index <= count; index++) {
            let e = document.createElement('div');
            e.className = 'progress__step';
            e.setAttribute('data-step', index);
            

            let a = document.createElement('a');
            a.setAttribute('data-step', index);
            a.setAttribute('href', '#step-' + index);
            a.innerHTML = svgIcon + index;
            e.appendChild(a);
            this.nodes.steps.push(e);
            this.nodes.links.push(a);
        }

        this.nodes.steps.forEach(elem => {
            this.nodes.step.appendChild(elem);
        });
        this.nodes.lineDecorationWrapper.appendChild(this.nodes.lineDecoration);
        this.nodes.line.appendChild(this.nodes.lineDecorationWrapper);
        this.nodes.element.appendChild(this.nodes.line);
        this.nodes.element.appendChild(this.nodes.step);
        this.nodes.wrapper.appendChild(this.nodes.element);
        target.appendChild(this.nodes.wrapper);
        
        this.step = 1;
    }
    get percent() {
        this._percent;
    }
    set percent(persent) {
        this._percent = parseFloat(parseFloat(persent).toFixed(2));
        this.nodes.line.style.width = this._percent + '%';


        // if (this._percent < 25) {
        //     this.nodes.lineDecoration.style.right = (() =>  -65 + 'px')();
        //     console.log(this.nodes.lineDecoration.style.right);
        // } else {
        //     this.nodes.lineDecoration.style.right = '0px';
        // }

        let stepsCount = this.nodes.steps.length;
        let activeStep = (stepsCount - 1) * (this._percent * 0.01);
        this.step = Math.floor(activeStep + 1);
    }
    get step() {
        return parseInt(this._step);
    }
    set step(step) {
        step = parseInt(step);
        this.nodes.steps.forEach(elem => {
            elem.classList.remove('active','passed');
            if ( parseInt(elem.dataset.step) < step) {
                elem.classList.add('passed');
            }
            if (parseInt(elem.dataset.step) === step) {
                elem.classList.add('active');
            }
        });
        this._step = step;
    }
    get direction() {
        return this._direction;
    }
    set direction(direction) {
        if (['forward', 'backward'].indexOf(direction) > -1) {
            this._direction = direction;
        }
    }
    on(eventName, callback) {
        [].forEach.call(this.nodes.links, item => {
            item.addEventListener(eventName, callback, false);
        });
    }
    hide() {
        this.nodes.wrapper.style.display = 'none';
    }
    show() {
        this.nodes.wrapper.style.display = 'block';
    }
}

module.exports = Progress;


// WEBPACK FOOTER //
// ./js/progress.js